import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';

import IntlMessages from 'util/IntlMessages';
import CustomScrollbars from 'util/CustomScrollbars';
import { Button } from '@material-ui/core';
import { requestGql } from 'constants/Request';

class SidenavContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listMenu: [
                {
                    id: "pages.dashboard",
                    icon: 'zmdi-home',
                    url: '/dashboard',
                    child: [],
                    action: 'dashboard'
                },
                {
                    id: "pages.user",
                    icon: 'zmdi-accounts',                    
                    child: [{
                        id: "pages.user.user",
                        url: '/user',
                        action: "accountAdmin"
                    },{
                        id: "pages.user.role",
                        url: '/adminRole',
                        action: "adminRole"
                    },{
                        id: "pages.user.adminPermission",
                        url: '/adminPermission',
                        action: "adminPermission"
                    },{
                        id: "pages.user.adminRolePermission",
                        url: '/adminRolePermission',
                        action: "adminRolePermission"
                    },{
                        id: "pages.user.adminUserRolePermission",
                        url: '/adminUserRolePermission',
                        action: "adminUserRolePermission"
                    }],
                    
                },
                {
                    id: "pages.patient",
                    icon: 'zmdi-account',
                    child: [
                        {
                            id: "pages.patient.individual",
                            url: '/patient/individual',
                            action: 'patientIndividual'
                        },
                        {
                            id: "pages.patient.individual_setting",
                            url: '/patient/individual_setting',
                            action:'settingPatientIndividual'
                        },
                        {
                            id: "pages.patient.business",
                            url: '/business',
                            action: 'business'
                        },
                        {
                            id: "pages.patient.corporate",
                            url: '/patient/corporate',
                            action: 'patientCorporate'
                        },
                        {
                            id: "pages.patient.delete",
                            url: '/patient/delete',
                            action: 'deletePatientCorporate'
                        },
                        {
                            id: "pages.patient.changeBusiness",
                            url: '/patient/changeBusiness',
                            action: 'changeBusiness'
                        },
                        {
                            id: "pages.patient.service",
                            url: '/patient/service',
                            action: 'servicePatient'
                        },
                        {
                            id: "pages.patient.TermOfUse",
                            url: '/patient/tou',
                            action: 'TermOfUse'
                        }
                    ]
                },
                {
                    id: "pages.hospital",
                    icon: 'zmdi-account-circle',
                    child: [
                        {
                            id: "pages.hospital.clinic",
                            url: '/hospital',
                            action: 'hospital'
                        },
                        {
                            id: "pages.hospital.doctor",
                            url: '/doctor',
                            action: 'doctor'
                        },
                        {
                            id: "pages.hospital.admin",
                            url: '/admin',
                            action: 'admin'
                        }
                    ]
                },
                {
                    id: "pages.realtimeStats",
                    icon: 'zmdi-time',
                    url: '/realtimeStats',
                    child: [],
                    action:"realtimeStats"
                },
                {
                    id: "pages.teleconference",
                    icon: 'zmdi-phone-in-talk',
                    url: '/teleconferenceLog',
                    child: [],
                    action: "teleconference"
                },
                {
                    id: "pages.Announcement",
                    icon: 'zmdi-volume-up',
                    url: '/announcement',
                    child: [],
                    action: "announcement"
                },
                {
                    id: "pages.prescription",
                    icon: 'zmdi-shopping-cart',
                    url: '/prescriptionpurchase',
                    child: [],
                    action: "prescription"
                },
                {
                    id: "pages.prescription_external",
                    icon: 'zmdi-shopping-cart',
                    url: '/prescriptionexternal',
                    child: [],
                    action:"prescriptionexternal"
                },
                {
                    id: "pages.promo",
                    icon: 'zmdi-pin',
                    url: '/promo',
                    child: [],
                    action: "promo"
                },
                {
                    id: "pages.voucher",
                    icon: 'zmdi-pin',
                    url: '/voucher',
                    child: [],
                    action: "voucher"
                },
                {
                    id: "pages.healthscreening",
                    icon: 'zmdi-account-circle',
                    child: [
                        {
                            id: "pages.marketplace",
                            url: '/marketPlace',
                            action: 'marketPlace'
                        },
                        {
                            id: "pages.redeem",
                            url: '/redeem',
                            action: 'redeem'
                        },
                        {
                            id: "pages.appointment",
                            url: '/appointment',
                            action: 'appointment'
                        }
                    ]
                },
                {
                    id: "pages.notify",
                    icon: 'zmdi-pin',
                    url: '/notify',
                    child: [],
                    action: "notify"
                },
                {
                    id: "pages.edmEmail",
                    icon: 'zmdi-pin',
                    url: '/edmEmail',
                    child: [],
                    action: "edmEmail"
                },
                {
                    id: "pages.drugslist",
                    icon: 'zmdi-phone-in-talk',
                    url: '/drugs/category',
                    child: [],
                    action: "drugs"
                },
                // {
                //     id: "pages.symptom",
                //     icon: 'zmdi-accounts',
                //     url: '/symptom',
                //     child: [],
                //     action: "symptom"
                // },
                {
                    id: "pages.symptom",
                    icon: 'zmdi-account',
                    child: [
                        {
                            id: "pages.symptom.category",
                            url: '/symptomCategory',
                            action: 'symptomCategory'
                        },
                        {
                            id: "pages.symptom.group",
                            url: '/symptomGroup',
                            action: 'symptomGroup'
                        },
                    ]
                },
                {
                    id: "pages.marketplacedrug",
                    icon: 'zmdi-account-circle',
                    child: [
                        {
                            id: "pages.marketplacedrug.all_drug",
                            url: '/all_drug',
                            action: 'presciption_drug'
                        },
                        {
                            id: "pages.marketplacedrug.category",
                            url: '/category',
                            action: 'purchase_drug'
                        },
                        {
                            id: "pages.marketplacedrug.purchase_drug",
                            url: '/purchased_drug',
                            action: 'normal_drug'
                        }
                    ]
                },
                {
                    id: "pages.report",
                    icon: 'zmdi-assignment',
                    child: [
                        {
                            id: "pages.report.sla_report",
                            url: '/report/sla_report',
                            action: 'sla_report'
                        },{
                            id: "pages.report.sla_report_status",
                            url: '/report/slaReportStatus',
                            action: 'slaReportStatus'
                        },{
                            id: "pages.report.waiting_room_analysis",
                            url: '/report/waitingRoomAnalysis',
                            action: 'waitingRoomAnalysis'
                        },{
                            id: "pages.report.teleconsult",
                            url: '/report/teleconsult',
                            action: 'teleconsultReport'
                        }
                    ]
                },
                {
                    id: "pages.version",
                    icon: 'zmdi-settings',
                    url: '/version',
                    child: [],
                    action: "version"
                },
                {
                    id: "pages.tool",
                    icon: 'zmdi-collection-case-play',
                    child: [
                        {
                            id: "pages.tool.ewallet",
                            url: '/ewallet',
                            action:'ewallet'
                        },
                        {
                            id: "pages.tool.menuplaceholder",
                            url: '/menuplaceholder',
                            action:'menuplaceholder'
                        },
                        {
                            id: "pages.tool.business_package",
                            url: '/businessPackage',
                            action:'businessPackage'
                        },
                        {
                            id: "pages.tool.main_speciality",
                            url: '/mainSpeciality',
                            action:'mainSpeciality'
                        },
                        {
                            id: "pages.tool.speciality",
                            url: '/speciality',
                            action:'speciality'
                        },
                        {
                            id: "pages.tool.profession",
                            url: '/profession',
                            action:'profession'
                        },
                        {
                            id: "pages.tool.profession_clinic_configuration",
                            url: '/professionClinicConfiguration',
                            action:'professionClinicConfiguration'
                        },
                        {
                            id: "pages.tool.gst_setting",
                            url: '/gstSetting',
                            action:'gstSetting'
                        },
                        {
                            id: "pages.tool.patient_all",
                            url: '/patientSearchAll',
                            action:'patientSearchAll'
                        },
                        {
                            id: "pages.tool.user_sessions",
                            url: '/userSessions',
                            action:'userSessions'
                        },
                        {
                            id: "pages.tool.waiting_room",
                            url: '/waitingRoom',
                            action:'waitingRoom'
                        },
                        {
                            id: "pages.tool.consent_template",
                            url: '/consentTemplate',
                            action:'consentTemplate'
                        },
                        {
                            id: "pages.tool.consent_user",
                            url: '/consentUser',
                            action:'consentUser'
                        },
                    ]
                },
                {
                    id: "pages.appointmentmanagement",
                    icon: 'zmdi-calendar',
                    child: [
                        {
                            id: "pages.appointmentmanagement.create",
                            url: '/createappointment',
                            action:'createappointment'
                        },
                        {
                            id: "pages.appointmentmanagement.update",
                            url: '/updateappointment',
                            action:'updateappointment'
                        },
                    ]
                },
                {
                    id: "pages.allappointment",
                    icon: 'zmdi-calendar',
                    url: '/appointmentmanagement/allappointments',
                    child: [],
                    action: 'appointmentmanagement',
                },
                {
                    id: "pages.waitingroommanagement",
                    icon: 'zmdi-smartphone-setting',
                    url: '/waitingRoomManagement',
                    child: [],
                    action: 'waitingRoomManagement',
                },
                {
                    id: "pages.logout",
                    icon: 'zmdi-undo',
                    url: '/logout',
                    child: [],
                    action: "logout"
                }
            ],
            listPermission: []
        }
    }
    componentDidMount() {
        const { history } = this.props;
        const that = this;
        const pathname = `${history.location.pathname}`; // get current path
        const query = `
        query{
            getPermissionAdmin{
                listPermission
                error{
                    code,
                    msg
                }
              }
          }
            `;
        requestGql(query)
            .then(result => {
                if (result.getPermissionAdmin) {
                    if (!result.getPermissionAdmin.error) {
                        let { listPermission } = result.getPermissionAdmin;
                        this.setState({
                            listPermission
                        }, () => {
                            const menuLi = document.getElementsByClassName('menu');
                            for (let i = 0; i < menuLi.length; i++) {
                                menuLi[i].onclick = function (event) {
                                    const parentLiEle = that.closest(this, 'li');
                                    if (
                                        menuLi[i].classList.contains('menu') &&
                                        parentLiEle !== null
                                    ) {
                                        event.stopPropagation();

                                        if (menuLi[i].classList.contains('open')) {
                                            menuLi[i].classList.remove('open', 'active');
                                        } else {
                                            menuLi[i].classList.add('open', 'active');
                                        }
                                    } else {
                                        for (let j = 0; j < menuLi.length; j++) {
                                            const parentLi = that.closest(this, 'li');
                                            if (
                                                menuLi[j] !== this &&
                                                (parentLi === null ||
                                                    !parentLi.classList.contains('open'))
                                            ) {
                                                menuLi[j].classList.remove('open');
                                            } else {
                                                if (menuLi[j].classList.contains('open')) {
                                                    menuLi[j].classList.remove('open');
                                                } else {
                                                    menuLi[j].classList.add('open');
                                                }
                                            }
                                        }
                                    }
                                };
                            }

                            const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
                            try {
                                const activeNav = this.closest(activeLi, 'ul'); // select closest ul
                                if (activeNav.classList.contains('sub-menu')) {
                                    this.closest(activeNav, 'li').classList.add('open');
                                } else {
                                    this.closest(activeLi, 'li').classList.add('open');
                                }
                            } catch (error) { }
                        });
                    } else {
                        console.log("==============getPermissionAdmin===", result.getPermissionAdmin.error.msg);
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });

    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { history } = nextProps;
        const pathname = `${history.location.pathname}`; // get current path

        const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
        try {
            const activeNav = this.closest(activeLi, 'ul'); // select closest ul
            if (activeNav.classList.contains('sub-menu')) {
                this.closest(activeNav, 'li').classList.add('open');
            } else {
                this.closest(activeLi, 'li').classList.add('open');
            }
        } catch (error) { }
    }

    closest(el, selector) {
        try {
            let matchesFn;
            // find vendor prefix
            [
                'matches',
                'webkitMatchesSelector',
                'mozMatchesSelector',
                'msMatchesSelector',
                'oMatchesSelector'
            ].some(function (fn) {
                if (typeof document.body[fn] === 'function') {
                    matchesFn = fn;
                    return true;
                }
                return false;
            });

            let parent;

            // traverse parents
            while (el) {
                parent = el.parentElement;
                if (parent && parent[matchesFn](selector)) {
                    return parent;
                }
                el = parent;
            }
        } catch (e) { }

        return null;
    }
    render() {
        let { listMenu, listPermission } = this.state;
        let renderMenu = listMenu.map(it => {
            if (it.child.length) {
                let isRender = false;
                let renderChild = it.child.map(child => {
                    if (listPermission.indexOf(child.action) > -1) {
                        console.log("111111111111111111111111111111")
                        isRender = true;
                        return (
                            <li key={child.id} >
                                <NavLink to={child.url}  >
                                    <span className="nav-text">
                                        <IntlMessages id={child.id} />{' '}
                                    </span>
                                </NavLink>
                            </li>
                        )
                    } else {
                        return null
                    }
                })
                console.log("33333333333333333333333", renderChild)
                if (isRender) {
                    return (
                        <li className="menu collapse-box" key={it.id}>
                            <Button>
                                <i className={`zmdi ${it.icon} zmdi-hc-fw`} />
                                <span className="nav-text">
                                    <IntlMessages id={it.id} />
                                </span>
                            </Button>
                            <ul className="sub-menu">
                                {renderChild}
                            </ul>
                        </li>
                    )
                } else {
                    return null
                }
            } else {
                if (listPermission.indexOf(it.action) > -1) {
                    return (
                        <li className="menu no-arrow" key={it.id}>
                            <NavLink to={it.url}>
                                <i className={`zmdi ${it.icon} zmdi-hc-fw`} />
                                <span className="nav-text">
                                    <IntlMessages id={it.id} />
                                </span>
                            </NavLink>
                        </li>
                    )
                } else {
                    return null
                }
            }
        })
        console.log("+++++++++++++", renderMenu)
        return (
            <CustomScrollbars className=" scrollbar">
                <ul className="nav-menu">
                    {renderMenu}
                   

                </ul>
                <br />
                <br />
            </CustomScrollbars>
        );
    }
}

export default withRouter(SidenavContent);
